<template>
  <transition name="fade">
    <div v-if="show" class="row mx-auto bg-light rounded p-3 mt-5" :class="[isUserConnected ? 'w-50' : 'w-75']">
      <div class="col-8" :class="[isUserConnected ? 'col-md-12' : 'col-md-6']">
        <FindByToken :href="$route('survey.findByToken')" />
      </div>
      <div v-if="!isUserConnected" class="col-12 d-flex flex-column" :class="[isUserConnected ? 'col-md-12' : 'col-md-6']">
        <p>
          Accédez à votre/vos questionnaire(s) en vous connectant à votre compte
          ROBVQ"
        </p>
        <a :href="loginUrl" class="btn btn-primary align-self-center">
          Se connecter
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
import AuthMixin from '../mixins/AuthMixin'
import UserMixin from '../mixins/UserMixin'
import FindByToken from '../Components/FindByToken.vue'

export default {
  components: { FindByToken },
  mixins: [AuthMixin, UserMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped>
.fade-enter-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-leave-active {
  transition: opacity 0.25s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
